import { FC, useState } from 'react';
import styled from 'styled-components';
import { boxShadow1, exactWhite, stringToColour } from 'utils/style/colors';
import SketchColorPicker from './SketchColorPicker';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { useDispatch } from 'react-redux';
import { updateSurveyReportColorMapAction } from 'store/survey/surveySlice';
import { IReportView } from 'store/survey/surveyTypes';

interface IProps {
  reportLables: string[];
  report: IReportView;
  colorMap: Record<string, string>;
  onSaveReport: ((report: IReportView) => Promise<any>) | undefined;
}

const ColorPickerContainer = styled.div`
  background-color: ${exactWhite};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
  border-radius: 0.5rem;
  box-shadow: ${boxShadow1};
`;

const ColorPickerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const QuestionLable = styled.div``;

const LabelColorPicker: FC<IProps> = ({
  reportLables,
  report,
  colorMap,
  onSaveReport,
}) => {
  const { t } = useTranslation('general');

  const dispatch = useDispatch();

  const [activeRow, setActiveRow] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleChangeLableColor = (label: string, color: string) => {
    dispatch(
      updateSurveyReportColorMapAction({
        reportId: report.id,
        colorMap: { ...colorMap, [label]: color } as Record<string, string>,
      })
    );
  };

  const handleUpdateReportColorMap = async () => {
    setLoading(true);
    onSaveReport?.(report)
      .then(() => {
        setLoading(false);
      })
      .catch((_: any) => {
        setLoading(false);
      });
  };

  return (
    <ColorPickerContainer>
      {reportLables.map((label: string, index: number) => (
        <ColorPickerRow key={index}>
          <QuestionLable>{label}</QuestionLable>
          <SketchColorPicker
            onChangeLableColor={(color: string) =>
              handleChangeLableColor(label, color)
            }
            color={colorMap?.[label] ?? stringToColour(label)}
            isEnabled={activeRow === index}
            disableColorPicker={() => setActiveRow(null)}
            openColorPicker={() => setActiveRow(index)}
          />
        </ColorPickerRow>
      ))}
      <Button
        onClick={handleUpdateReportColorMap}
        loading={loading}
        color="black-outline"
      >
        {t('saveColorMap')}
      </Button>
    </ColorPickerContainer>
  );
};

export default LabelColorPicker;
